export default {};
throw new Error(`Could not resolve "@react-three/drei" imported by "@appletosolutions/reactbits". Is it installed?`)